import * as Styled from './Logo.style'

const Logo = () => {
    return (
        <Styled.Div>
            <img src={`/aquarium/tank-life.png`} alt={'tank.life'} />
        </Styled.Div>
    )
}

export default Logo